/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from '@polleverywhere/backbone'
import _ from 'underscore'
import JsonAPI from './json_api'
import URI from 'urijs'

/*
 * Paginated Collection that can be used directly or inherited.
 */
export default class PaginatedCollection extends Backbone.Collection {
  initialize () {
    this.api = new JsonAPI()
  }

  nextPage (options) {
    if (options == null) { options = {} }
    const uri = URI(this.api.links('next'))
    const url = uri.toString().replace(uri.search(), '')

    _.extend(options, {
      url,
      data: uri.search(true)
    }
    )

    return this.fetch(options)
  }

  prevPage (options) {
    if (options == null) { options = {} }
    const uri = URI(this.api.links('prev'))
    const url = uri.toString().replace(uri.search(), '')

    _.extend(options, {
      url,
      data: uri.search(true)
    }
    )

    return this.fetch(options)
  }

  fetch (options) {
    if (options == null) { options = {} }
    if (options.page) {
      if (!options.data) { options.data = {} }
      _.extend(options.data,
        { page: options.page })
    }

    return super.fetch(options)
  }

  currentPage () {
    return this.api.meta('current_page')
  }

  totalPages () {
    return this.api.meta('total_pages')
  }

  totalCount () {
    return this.api.meta('total_count')
  }

  parse (json, options) {
    this.api.clear({ silent: true })
    this.api.set(json)
    return this.api.data()
  }
}
